.container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.chartHeaderWrapper {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.leftHeaderNode {
  flex: 1;
  min-width: 0;

  [data-entity-header-watchlist] {
    padding: 0;
  }
}

.priceWrapper {
  flex-shrink: 0;
}
